<template>
  <div>
    <div class="spinner_hold" v-if="loading">
      <div class="spin">
        <i class="fa fa-spinner fa-spin"></i>
        <span>{{loadingMessage}} ...</span>
      </div>
    </div>
    <div class="error_hold" v-if="error">
      <h5>Error fetching data!</h5>
      <p>{{errorMessage}}</p>
    </div>
    <div v-if="!error && !loading">
      <!-- validation messages -->
      <section v-if="loadingData">
        <div class="centric-hold-80">
          <div class="wrapp-rt2">
            <div class="row mt-50">
              <div class="spinner_hold">
                <div class="spin">
                  <i class="fa fa-spinner fa-spin"></i>
                  <span>Loading, please wait ...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section v-if="errorLoadingData.length > 0">
        <div class="centric-hold-80">
          <div class="wrapp-rt2">
            <div class="row mt-50">
              <div class="error_hold">
                <h5>Sorry, there was a problem!</h5>
                <p v-for="item in errorLoadingData" :key="item">{{item}}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- validation message end -->
      <section v-if="errorLoadingData.length <= 0 && !loadingData">
        <div class="centric-hold-80 mt-20">
          <div class="row">
            <div v-if="booking_options==env_bd" class="col-md-12 col-sm-12">
              <h3 class="verified-heading">
                <span class="verified-booking">
                  <i class="material-icons">verified_user</i>
                </span>We have received your request for an appointment with
                <span>{{providerTitle}} {{providerFirstName}} {{providerLastName}}</span>. After processing the request, we will send a confirmation message to your phone number
                <strong>{{personMobile}}</strong> and
                <strong>{{personEmail}}</strong>.
              </h3>
            </div>
            <div v-if="booking_options==env_bvr" class="col-md-12 col-sm-12">
              <h3 class="verified-heading">
                <span class="verified-booking">
                  <i class="material-icons">verified_user</i>
                </span>We have received your request for an appointment with
                <span>{{providerTitle}} {{providerFirstName}} {{providerLastName}}</span>
                . We will try our best to accommodate your time preference and will send a confirmation over email to {{personEmail}}. You can also contact
                <span style="text-decoration: underline;">{{providerEmail}}</span> in case of any questions.
              </h3>
            </div>
          </div>
        </div>
        <!-- START Dr Neha Payment LIVE -->
        <div v-if="tenant_id=='94be5b4c-9ddc-4bd1-8c6c-07768ebd1908'" class="centric-hold-80 mt-20">
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <div class="customPaymentContainer">
                <h3 class="verified-heading">
                  To proceed with booking your appointment, please make the payment through
                  one of the following methods:
                </h3>
                <div class="row mt-20">
                  <div class="col-md-6">
                    <div class="col-md-12">
                      <div class="paymentMethodContainer paymentDesign-1">
                        <h1 class="verified-heading">Charges</h1>
                        <h5>
                          <b>Domestic Patient (India) :</b> Rs. 700 /-
                        </h5>
                        <h5>
                          <b>International Patient (Outside India) :</b> Rs. 1,000 /-
                        </h5>
                        <h5>Medicines and Couriers Charges are Extra.</h5>
                      </div>
                    </div>
                    <div class="col-md-12 mt-30">
                      <div class="paymentMethodContainer paymentDesign-1">
                        <h1 class="verified-heading">Bank Transfer</h1>
                        <h5>
                          <b>Account Holder:</b> Dr. Neha's Clinic
                        </h5>
                        <h5>
                          <b>Account Number:</b> 00261500017967
                        </h5>
                        <h5>
                          <b>Bank Name:</b> HDFC Bank
                        </h5>
                        <h5>
                          <b>Branch:</b> New Delhi - Orn Market
                        </h5>
                        <h5>
                          <b>IFSC Code:</b> HDFC0000026
                        </h5>
                      </div>
                    </div>
                    <div class="col-md-12 mt-30">
                      <div class="paymentMethodContainer paymentDesign-1">
                        <h1 class="verified-heading">Paypal</h1>
                        <h5>
                          <b>
                            <a
                              href="https://www.paypal.com/ncp/payment/Z9QD26KJEAUWY"
                            >nehagera@gmail.com</a>
                          </b>
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-30">
                    <div class="paymentMethodContainer paymentDesign-1">
                      <h1 class="verified-heading">Scan to pay with any UPI App</h1>
                      <div class="qrImageContainer">
                        <img
                          class="qrImage mt-20"
                          src="https://genamet-static-uploads-prod.s3.ap-south-1.amazonaws.com/images/dr_neha_qr.png"
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="paymentMethodContainer mt-20">
                  <h1 class="verified-heading mt-20">Important Note:</h1>
                  <h5>
                    Appointment scheduling will be confirmed only after the payment is successfully made. Once
                    you've completed the payment, kindly take a screenshot of the transaction confirmation and send
                    it to
                    <span>
                      <a href="https://wa.me/+919312435467">9312435467</a>
                    </span> via WhatsApp.
                  </h5>
                  <h5>
                    Upon receiving your payment confirmation, our clinic will revert to you with the confirmed date
                    and time for your appointment.
                  </h5>
                  <h5>
                    For any inquiries or assistance regarding the payment process, feel free to contact us at
                    9312435467. We're here to help!
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END Dr Neha Payment LIVE -->
      </section>
      <!-- mid content starts -->
      <section class="mid-spacer" v-if="!loadingData">
        <div class="centric-hold-80 mt-20">
          <div class="wrapp-rt2" v-if="errorLoadingData.length <= 0">
            <div class="row">
              <!-- Left panel -->
              <div class="col-md-6 col-sm-6 col-xs-12">
                <div class="row details-box-hold">
                  <div class="col-md-12 col-sm-12 col-xs12 no-pad">
                    <div class="row">
                      <div class="col-md-3 col-sm-3 col-xs-12">
                        <div class="media-left">
                          <!-- <img v-if="providerId" :src="getImgUrl(providerId + '-profile-photo')" class="media-object"> -->
                          <img :src="getImgUrlProfile(providerPic)" class="media-object">
                        </div>
                      </div>
                      <div class="col-md-9 col-sm-9 col-xs-12">
                        <div class="media-body">
                          <h4
                            class="media-heading"
                          >{{providerTitle}} {{providerFirstName}} {{providerLastName}}</h4>
                          <p v-html="providerQual"></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row details-box-hold">
                  <div class="col-md-12 col-sm-12 col-xs12 no-pad">
                    <div class="row">
                      <div class="col-md-3 col-sm-3 col-xs-12">
                        <div class="media-left">
                          <!-- <img :src="getImgUrl(businessId)" class="media-object"> -->
                          <img :src="getImgUrl(businessLogo)" class="media-object">
                        </div>
                      </div>
                      <div class="media-body">
                        <div class="col-md-9 col-sm-9 col-xs-12">
                          <!-- <h4 class="media-heading">{{businessName}}</h4> -->
                          <h4 class="media-heading" v-if="locationName">{{locationName}}</h4>
                          <p v-if="clinicAddress" v-html="clinicAddress"></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Right panel -->
              <div class="col-md-6 col-sm-6 col-xs-12">
                <div class="details-box-hold-rt">
                  <div class="row" v-if="booking_options==env_bd">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                      <div class="m-icon">
                        <i class="material-icons">date_range</i>
                      </div>
                      <p>
                        <span>On</span>
                        {{appointmentDate | moment("MMM DD, YYYY") }}
                      </p>
                    </div>

                    <div class="col-md-6 col-sm-6 col-xs-12">
                      <div class="m-icon">
                        <i class="material-icons">access_time</i>
                      </div>
                      <p>
                        <span>At</span>
                        {{appointmentDate | moment("hh:mm A") }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="order_id">
                  <h5 v-if="order_status == 'Success'">
                    <span class="success-payment">
                      <i class="material-icons">check_circle</i>
                    </span>Thank you. Your payment was successful.
                  </h5>
                  <h5 v-else>
                    <span class="failed-payment">
                      <i class="material-icons">clear</i>
                    </span>Sorry, your payment did not go through.
                  </h5>
                  <div class="table-responsive">
                    <table class="table">
                      <tr v-if="tracking_id">
                        <td style="width:30%">Transaction id :</td>
                        <td style="font-weight:600;">{{tracking_id}}</td>
                      </tr>
                      <tr style="border-bottom:1px solid #eeeeee;">
                        <td style="width:30%">ORDER STATUS :</td>
                        <td style="font-weight:600;">{{order_status}}</td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="row" v-else>
                  <h5>
                    <span class="success-payment">
                      <i class="material-icons">check_circle</i>
                    </span>Thank you. You have chosen to pay later.
                  </h5>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <p>
                      <span>
                        <b>Service :</b>
                      </span>
                      &nbsp;&nbsp;&nbsp;&nbsp; {{serviceName}}
                    </p>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6 col-sm-6 col-xs-12 no-pad">
                    <div class="col-md-12">
                      <p>
                        <span>
                          <b>Patient / Visitor name :</b>
                        </span>
                        <br>
                        {{personName}}
                      </p>
                    </div>
                  </div>

                  <div class="col-md-6 col-sm-6 col-xs-12">
                    <div class="col-md-12">
                      <p>
                        <span>
                          <b>Email :</b>
                        </span>
                        <br>
                        {{personEmail}}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <p>
                      <span>
                        <b>Mobile :</b>
                      </span>
                      &nbsp;&nbsp;&nbsp;&nbsp;{{personMobileCC}}-{{personMobile}}
                    </p>
                  </div>
                </div>

                <div class="row" v-if="booking_options==env_bvr">
                  <div class="col-md-12">
                    <p>
                      <span>
                        <b>Your Request</b>
                      </span>
                      <br>
                      {{truncateText(preferredScheduleNotes, 50)}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="wrapp-rt2 pad-20">
            <button
              type="button"
              @click="bookAnother"
              class="btn btn-primary btn-prime pull-right"
            >Book another appointment</button>
            <button type="button" @click.prevent="goHome()" class="btn btn-primary btn-sec">Home</button>
          </div>
        </div>
      </section>
      <!-- mid content ends -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import tz from "moment-timezone";
import axios from "axios";

export default {
  name: "BookingConfirmationPage",
  data() {
    return {
      order_id: "",
      tracking_id: "",
      bank_ref_no: "",
      order_status: "",
      failure_message: "",
      payment_mode: "",
      card_name: "",
      status_code: "",
      status_message: "",
      currency: "",
      amount: "",
      appointment_id: "",
      temp_appointment_id: "",
      tenant_id: "",
      preferredScheduleNotes: "",
      service_mode: "",
      booking_options: "",
      env_bvr: process.env.VUE_APP_BOOKING_OPTIONS_BVR,
      env_bd: process.env.VUE_APP_BOOKING_OPTIONS_BD,
      env_pay_later: process.env.VUE_APP_PAYMENT_PREFERENCE_PAY_LATER,
      env_pay_now: process.env.VUE_APP_PAYMENT_PREFERENCE_PAY_NOW,
      env_pay_any: process.env.VUE_APP_PAYMENT_PREFERENCE_ANY,
      // billing_name: "",
      // billing_address: "",
      // billing_city: "",
      // billing_state: "",
      // billing_zip: "",
      // billing_country: "",
      // billing_tel: "",
      // billing_email: "",
      // provider_id: "",
      // tenant_id: "",
      // billing_notes: "",
      personName: "",
      personEmail: "",
      personMobile: "",
      personMobileCC: "",
      appointmentDate: "",
      serviceName: "",
      trans_date: "",
      booking_data: "",
      payment_option: "",
      loadingData: false,
      errorLoadingData: [],
      onPageValidationErrors: [],
      razorPayResponse: {}
    };
  },
  methods: {
    getImgUrl(val) {
      if (val) {
        var images =
          process.env.VUE_APP_STATIC_FILES +
          "/" +
          this.$store.getters.tenantId +
          "/images/logo/" +
          val;
        return images;
      } else {
        var images =
          "https://s3.amazonaws.com/genamet-static-uploads/common/genamet-no-logo.png";
        return images;
      }
    },
    getImgUrlProfile(val) {
      console.log(process.env.VUE_APP_STATIC_FILES + " static files path");
      if (val) {
        var images =
          process.env.VUE_APP_STATIC_FILES +
          "/" +
          this.$store.getters.tenantId +
          "/images/profile_photo/" +
          val;
        return images;
      } else {
        var images =
          "https://s3.amazonaws.com/genamet-static-uploads/common/noprofilephoto.jpg";
        return images;
      }
    },
    bookAnother() {
      this.clearLocalStorage();
      this.$router.push(
        "/book-appointment/" +
          this.$store.getters.locationId +
          "/" +
          this.$store.getters.providerId
      );
    },
    goHome() {
      this.clearLocalStorage();
      var currentUrl = window.location.hostname;
      console.log("currentUrl >> " + currentUrl);

      if (currentUrl.indexOf("arista") >= 0) {
        window.location.href = process.env.VUE_APP_CLINIC_URL_ARISTA;
      }

      if (currentUrl.indexOf("pranav-skin-and-cosmetology-clinic") >= 0) {
        window.location.href = process.env.VUE_APP_CLINIC_URL_PRANAV;
      }

      if (currentUrl.indexOf("acharya-tulasi-jain-hospital") >= 0) {
        window.location.href = process.env.VUE_APP_CLINIC_URL_SANGEETHA;
      }

      if (currentUrl.indexOf("padmanabhan-clinic") >= 0) {
        window.location.href = process.env.VUE_APP_CLINIC_URL_PADMANABHAN;
      }

      if (currentUrl.indexOf("priyans-dental-clinic") >= 0) {
        window.location.href = process.env.VUE_APP_CLINIC_URL_PRIYANS;
      }

      if (currentUrl.indexOf("vijay-seshadri-clinic") >= 0) {
        window.location.href = process.env.VUE_APP_CLINIC_URL_VIJAYSESHADRI;
      }

      if (
        currentUrl.indexOf(process.env.VUE_APP_CLINIC_NAME_NEWLIFEHOSPITALS) >=
        0
      ) {
        window.location.href = process.env.VUE_APP_CLINIC_URL_NEWLIFEHOSPITALS;
      }
      // console.log("Hi: ",currentUrl.indexOf("NotPresentInEnv"))
      if (currentUrl.indexOf("NotPresentInEnv") == -1) {
        window.location.href = this.minisiteUrl;
      }
      // if( currentUrl.indexOf('localhost') >= 0){
      //     window.location.href=process.env.VUE_APP_CLINIC_URL_VIJAYSESHADRI;
      // }
    },
    clearLocalStorage() {
      localStorage.setItem("personName", JSON.stringify(""));
      localStorage.setItem("personEmail", JSON.stringify(""));
      localStorage.setItem("personMobile", JSON.stringify(""));
      localStorage.setItem("personMobileCC", JSON.stringify(""));
      localStorage.setItem("serviceName", JSON.stringify(""));
      localStorage.setItem("appointmentDate", JSON.stringify(""));
      localStorage.setItem("preferredScheduleNotes", JSON.stringify(""));
      localStorage.setItem("service_mode", JSON.stringify(""));
      localStorage.setItem("booking_options", JSON.stringify(""));
      localStorage.setItem("providerEmail", JSON.stringify(""));
      localStorage.setItem("locationName", JSON.stringify(""));
      localStorage.setItem("businessName", JSON.stringify(""));
      localStorage.removeItem(this.temp_appointment_id);
      localStorage.removeItem("pmntcptrddata");
      localStorage.removeItem("generatedappid");
    },
    sendText() {
      // send text ...
      let url =
        process.env.VUE_APP_FRONTEND_API_BASE +
        "/api/appointment/notify?aid=" +
        this.appointment_id;

      axios
        .get(url, {
          headers: {
            "Content-Type": "application/json",
            x_tenant_id: this.tenant_id,
            "Accept-Encoding": "gzip"
          }
        })
        .then(response => {
          console.log("Text sent!");
        })
        .catch(e => {
          console.log("Text not sent!");
        });
      // -- send text ends
    },
    truncateText(textVal, length) {
      return textVal.substring(0, length) + " ... ";
    },
    book_appointment() {
      this.loadingData = true;
      console.log("in ba ... " + this.payment_option);
      let currentTenantId = this.tenant_id;
      // Anuj - Queue - Set this to the new book url which adds to the queue
      // 24 May 2019 - 14:13 hrs
      // let appointment_url = "http://localhost:49600/api/v1/appointment";
      let appointment_url =
        process.env.VUE_APP_ANONYMOUS_API_BASE + "appointment";
      // let appointment_url = process.env.VUE_APP_FRONTEND_API_BASE+'/api/appointment/book';
      // -- Anuj - Queue - Set this to the new book url which adds to the queue
      // -- 24 May 2019 - 14:13 hrs
      let staffId = this.booking_data.provider.unique_id;
      let role_unique_id = process.env.VUE_APP_ROLE_UNIQUE_ID;
      let taid = this.temp_appointment_id;
      if (this.booking_options == process.env.VUE_APP_BOOKING_OPTIONS_BD) {
        axios
          .post(appointment_url, JSON.stringify(this.booking_data), {
            headers: {
              "Content-Type": "application/json",
              x_tenant_id: currentTenantId,
              role_unique_id: role_unique_id,
              loggedin_user_unique_id: staffId,
              route_entity_name: "/appointment"
              // taid: taid
            }
          })
          .then(response => {
            this.loadingData = false;
            let link_object = {};
            if (response.statusCode == 500 || response.statusCode == 400) {
              if (
                this.payment_option == "pay_now" &&
                this.order_status == "Success"
              ) {
                this.errorLoadingData.push(
                  "Failed to create an Appointment. For any payment/booking related issues or refunds, please contact us and share you Email and Phone Number used while booking!"
                );
                link_object.status = "NEW_APPT_CREATE_FAILED_PAYMENT_SUCCEEDED";
              } else if (this.payment_option == "pay_later") {
                this.errorLoadingData.push("Could not create an Appointment!");
                link_object.status = "NEW_APPT_CREATE_FAILED_PAY_LATER";
              } else if (
                this.payment_option == "pay_now" &&
                this.order_status != "Success"
              ) {
                this.errorLoadingData.push(
                  "Failed to create an Appointment. There also seems to be a problem with processing your payment. Please try to book again!"
                );
                link_object.status = "NEW_APPT_CREATE_FAILED_PAYMENT_FAILIED";
              }

              this.appointment_id = "";
              // Call api to link temp aid WITH booking object
              link_object.payload = this.booking_data;
              link_object.temp_aid = this.temp_appointment_id;
              link_object.real_aid = "";
              link_object.providerEmail = this.$store.getters.providerEmail;
              link_object.businessName = this.$store.getters.businessName;
              link_object.locationName = this.$store.getters.locationName;
              this.rel_aid(link_object);
              // end call to link temp aid WITH booking object
              localStorage.setItem(this.temp_appointment_id, "{}");
            } else {
              // Anuj - Queue - store message id from queue, instead of result
              // In the appt book queue handler, wait and then, get appt id, update in rel table replacing the message id id
              // 24 May 2019 - 14:15 hrs
              // this.appointment_id = response.data.result;
              this.appointment_id = "M#" + response.data.MessageId;
              localStorage.setItem("generatedappid", this.appointment_id);
              // Anuj - Queue - store message id from queue, instead of result
              // In the appt book queue handler, wait and then, get appt id, update in rel table replacing the message id id
              // 24 May 2019 - 14:15 hrs

              // Call api to link temp aid to real aid without booking object
              if (this.payment_option == "pay_now") {
                link_object.status =
                  "NEW_APPT_CREATE_SUCCESSFUL_PAYMENT_SUCCESSFUL";
              } else {
                link_object.status = "NEW_APPT_CREATE_SUCCESSFUL_PAY_LATER";
              }
              link_object.payload = "";
              link_object.temp_aid = this.temp_appointment_id;
              link_object.real_aid = this.appointment_id;
              link_object.providerEmail = this.$store.getters.providerEmail;
              link_object.businessName = this.$store.getters.businessName;
              link_object.locationName = this.$store.getters.locationName;
              this.rel_aid(link_object);
              // end call to link temp aid to real aid without booking object
              localStorage.setItem(this.temp_appointment_id, "{}");
            }
          })
          .catch(error => {
            console.log("Error in the book appt api call");
            console.log(error);

            let link_object = {};

            if (
              this.payment_option == "pay_now" &&
              this.order_status == "Success"
            ) {
              this.errorLoadingData.push(
                "Failed to create an Appointment. For any payment/booking related issues or refunds, please contact us and share you Email and Phone Number used while booking!"
              );
              link_object.status = "NEW_APPT_CREATE_FAILED_PAYMENT_SUCCEEDED";
            } else if (this.payment_option == "pay_later") {
              this.errorLoadingData.push("Could not create an Appointment!");
              link_object.status = "NEW_APPT_CREATE_FAILED_PAY_LATER";
            } else if (
              this.payment_option == "pay_now" &&
              this.order_status != "Success"
            ) {
              this.errorLoadingData.push(
                "Failed to create an Appointment. There also seems to be a problem with processing your payment. Please try to book again!"
              );
              link_object.status = "NEW_APPT_CREATE_FAILED_PAYMENT_FAILIED";
            }

            this.appointment_id = "";
            // Call api to link temp aid WITH booking object
            link_object.payload = this.booking_data;
            link_object.temp_aid = this.temp_appointment_id;
            link_object.real_aid = "";
            link_object.providerEmail = this.$store.getters.providerEmail;
            link_object.businessName = this.$store.getters.businessName;
            link_object.locationName = this.$store.getters.locationName;
            this.rel_aid(link_object);
            // end call to link temp aid WITH booking object
            localStorage.setItem(this.temp_appointment_id, "{}");
            this.loadingData = false;
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
            console.log(error.response.data.message);
            this.errorLoadingData.push(error.response.data.message);
          });
      }
      if (this.booking_options == process.env.VUE_APP_BOOKING_OPTIONS_BVR) {
        let link_object = {};
        this.loadingData = false;
        console.log("in ba sm 1");
        // Store appointment request with temp aid in database
        // Status should be a 'contact request'
        // Send email to configured contact
        if (this.payment_option == "pay_now") {
          link_object.status =
            "NEW_APPT_REQUEST_CREATE_SUCCESSFUL_PAYMENT_SUCCESSFUL";
        } else {
          link_object.status = "NEW_APPT_REQUEST_CREATE_SUCCESSFUL_PAY_LATER";
        }
        this.appointment_id = "";
        // Call api to link temp aid WITH booking object
        link_object.payload = JSON.stringify(this.booking_data);
        link_object.temp_aid = this.temp_appointment_id;
        link_object.real_aid = "";
        link_object.preferredScheduleNotes = this.preferredScheduleNotes;
        link_object.providerEmail = JSON.parse(
          localStorage.getItem("providerEmail")
        ); //this.$store.getters.providerEmail;
        link_object.businessName = JSON.parse(
          localStorage.getItem("businessName")
        ); //this.$store.getters.businessName;
        link_object.locationName = JSON.parse(
          localStorage.getItem("locationName")
        ); //this.$store.getters.locationName;
        this.rel_aid(link_object);
        // end call to link temp aid WITH booking object
        localStorage.setItem(this.temp_appointment_id, "{}");
      }
    },
    rel_aid(payload) {
      this.loadingData = true;
      let currentTenantId = this.tenant_id;
      let aid_rel_url =
        process.env.VUE_APP_FRONTEND_API_BASE + "/api/appointment/aid-rel";
      axios
        .post(aid_rel_url, JSON.stringify(payload), {
          headers: {
            "Content-Type": "application/json",
            x_tenant_id: currentTenantId
          }
        })
        .then(response => {
          this.loadingData = false;
        })
        .catch(error => {
          console.log("Error in sending request!");
          console.log(error);
          this.loadingData = false;
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
          console.log(error.response.data.message);
          this.errorLoadingData.push(error.response.data.message);
        });
    }
  },
  mounted() {
    debugger;
    console.log("mounted");
    this.tenant_id = JSON.parse(localStorage.getItem("tenantId"));
    this.personName = JSON.parse(localStorage.getItem("personName"));
    this.personEmail = JSON.parse(localStorage.getItem("personEmail"));
    this.personMobile = JSON.parse(localStorage.getItem("personMobile"));
    this.personMobileCC = JSON.parse(localStorage.getItem("personMobileCC"));
    this.appointmentDate = JSON.parse(localStorage.getItem("appointmentDate"));
    this.serviceName = JSON.parse(localStorage.getItem("serviceName"));
    this.preferredScheduleNotes = JSON.parse(
      localStorage.getItem("preferredScheduleNotes")
    );
    this.service_mode = JSON.parse(localStorage.getItem("service_mode"));
    this.booking_options = JSON.parse(localStorage.getItem("booking_options"));

    if (this.$route.query.aid) {
      this.temp_appointment_id = this.$route.query.aid;
    } else {
      this.temp_appointment_id = this.$route.query.merchant_param1;
    }
    if (!localStorage.hasOwnProperty(this.temp_appointment_id)) {
      this.$router.push("/");
    }
    console.log("--mounted " + this.service_mode);
  },
  watch: {},
  created() {
    debugger;
    this.personName = JSON.parse(localStorage.getItem("personName"));
    this.personEmail = JSON.parse(localStorage.getItem("personEmail"));
    this.personMobile = JSON.parse(localStorage.getItem("personMobile"));
    this.personMobileCC = JSON.parse(localStorage.getItem("personMobileCC"));
    this.appointmentDate = JSON.parse(localStorage.getItem("appointmentDate"));
    this.serviceName = JSON.parse(localStorage.getItem("serviceName"));
    this.preferredScheduleNotes = JSON.parse(
      localStorage.getItem("preferredScheduleNotes")
    );
    this.service_mode = JSON.parse(localStorage.getItem("service_mode"));
    this.booking_options = JSON.parse(localStorage.getItem("booking_options"));
    debugger;
    console.log("created " + this.service_mode);
    if (localStorage.pmntcptrddata) {
      this.razorPayResponse = JSON.parse(localStorage.pmntcptrddata);
    }
    if (this.$route.query.aid) {
      this.payment_option = "pay_later";
      this.temp_appointment_id = this.$route.query.aid;
    } else {
      this.payment_option = "pay_now";
      this.temp_appointment_id = this.$route.query.merchant_param1;
      this.order_id = this.$route.query.order_id;
      this.tracking_id = this.$route.query.tracking_id;
      this.bank_ref_no = this.$route.query.bank_ref_no;
      this.order_status = this.$route.query.order_status;
      this.failure_message = this.$route.query.failure_message;
      this.payment_mode = this.$route.query.payment_mode;
      this.card_name = this.$route.query.card_name;
      this.status_code = this.$route.query.status_code;
      this.status_message = this.$route.query.status_message;
      this.currency = this.$route.query.currency;
      this.amount = this.$route.query.amount;
      this.billing_name = this.$route.query.billing_name;
      this.billing_address = this.$route.query.billing_address;
      this.billing_city = this.$route.query.billing_city;
      this.billing_state = this.$route.query.billing_state;
      this.billing_zip = this.$route.query.billing_zip;
      this.billing_country = this.$route.query.billing_country;
      this.billing_tel = this.$route.query.billing_tel;
      this.billing_email = this.$route.query.billing_email;
      this.billing_notes = this.$route.query.billing_notes;
      this.trans_date = this.$route.query.trans_date;
    }

    this.tenant_id = JSON.parse(localStorage.getItem("tenantId"));

    // Book appointment
    if (localStorage.hasOwnProperty(this.temp_appointment_id)) {
      this.booking_data = JSON.parse(
        localStorage.getItem(this.temp_appointment_id)
      );
    } else {
      this.booking_data = "";
    }

    console.log("this.booking_data: " + this.booking_data);

    if (this.booking_data != "" && Object.keys(this.booking_data).length != 0) {
      // If pay_later
      // book appointment
      // handle error / success
      if (this.payment_option == "pay_later") {
        this.book_appointment();
      }

      // If pay_now
      // If payment_was_successful
      // book appointment
      // handle error / success
      if (this.payment_option == "pay_now") {
        if (this.order_status == "Success") {
          this.book_appointment();
        } else {
          // Sorry, your payment has failed. Appoitment was not created.
          this.errorLoadingData.push(
            "Failed to create an Appointment because your payment did not go through. Please try to book again!"
          );
        }
      }
    }

    //End Book Appointment

    this.personName = JSON.parse(localStorage.getItem("personName"));
    this.personEmail = JSON.parse(localStorage.getItem("personEmail"));
    this.personMobile = JSON.parse(localStorage.getItem("personMobile"));
    this.personMobileCC = JSON.parse(localStorage.getItem("personMobileCC"));
    this.appointmentDate = JSON.parse(localStorage.getItem("appointmentDate"));
    this.serviceName = JSON.parse(localStorage.getItem("serviceName"));
    this.preferredScheduleNotes = JSON.parse(
      localStorage.getItem("preferredScheduleNotes")
    );
    this.service_mode = JSON.parse(localStorage.getItem("service_mode"));
    this.booking_options = JSON.parse(localStorage.getItem("booking_options"));
    //this.sendText();
    console.log("--created");
  },
  computed: {
    ...mapGetters([
      "tenantId",
      "protocol",
      "subDomain",
      "businessId",
      "businessLogo",
      "businessName",
      "businessType",
      "businessWebsiteUrl",
      "providerTitle",
      "providerFirstName",
      "providerLastName",
      "providerEmail",
      "providerId",
      "providerColorCode",
      "providerPhone",
      "providerQual",
      "providerPic",
      "locationName",
      "clinicContactNumbers",
      "clinicAddress",
      "locationId",
      "locationCurrency",
      "locationTz",
      "mapUrlEmbedded",
      "clientTz",
      "loading",
      "loadingMessage",
      "error",
      "errorMessage",
      "minisiteUrl"
    ])
  }
};
</script>

<style>
/*Dr Neha temprory Payment LIVE*/
.customPaymentContainer .verified-heading {
        float: none;
    }

    .customPaymentContainer h5 {
        padding-top: 12px;
    }
    .paymentDesign-1 {
        border: 1px solid #e0e0e0;
        padding: 20px;
    }
    .customPaymentContainer .mt-30{
        margin-top: 30px;
    }
    .qrImageContainer {
    background: #f3f6fd;
    border-radius: 10px;
    margin-top: 15px;
    padding: 10px 0;
}
.customPaymentContainer .qrImage {
        max-width: 100%;
        margin:0 auto;
        display: block;
    }
    .customPaymentContainer .row.mt-20 .col-md-6:first-child {
    padding-right: 0;
    padding-left: 0;
}
.customPaymentContainer a{
    color:#00bcd2;
}
@media (min-width:768px){
    .customPaymentContainer .row.mt-20 .col-md-6.mt-30{
        margin-top:0;
    }
}
/*Dr Neha temprory Payment LIVE*/
</style>
